module.exports = __webpack_public_path__ + "static/media/S (182).ceaf1671.jpg";